// extracted by mini-css-extract-plugin
export default {"crumbs":"Breadcrumbs_crumbs__Wl7kI","sep":"Breadcrumbs_sep__Hx-9l"};